module.exports = __webpack_public_path__ + "assets/img/tx11g_2.541f09d2.jpg";